import {
  TableBody,
  TableFooter,
  TableHeader,
} from '../styles/TimesheetsTable.styled';
import {
  TimeTrackingAssignment,
  TimeTracking,
  TimeTrackingDayEntry,
} from 'src/tabs/models/TimesheetsInterface';
import { LoadingSpinner } from 'src/components/common/LoadingSpinner/LoadingSpinner';
import { DaysForecastedHours } from '../utils/getForecasteHours';
import { MobileTimeSheetsHeaderRow } from './MobileTimesheetsHeaderRow';
import { MobileTimesheetsFooterRow } from './MobileTimesheetsFooterRow';
import { MobileTimeSheetsBodyRow } from './MobileTimesheetsBodyRow';
import {
  MobileDataTable,
  MobileTimesheetsScroll,
  MobileTimesheetsTablesWrapper,
  MobileTitlesTable,
} from './styles/MobileTimesheets.styled';

interface MobileTimesheetsTableProps {
  loadingTimesheets: boolean;
  mappedTimesheetsData: {
    assignment: TimeTrackingAssignment;
    dayEntries: TimeTrackingDayEntry[];
  }[];
  getAssignments: () => Promise<void>;
  headerData: {
    title: string;
    new_date: string;
  }[];
  footerData: string[];
  forecastedHours: DaysForecastedHours[];
  anyPopupsOpen?: boolean;
  setAnyPopupsOpen?: (value: boolean) => void;
}

export const MobileTimesheetsTable = ({
  loadingTimesheets,
  getAssignments,
  mappedTimesheetsData,
  headerData,
  footerData,
  forecastedHours,
  anyPopupsOpen,
  setAnyPopupsOpen,
}: MobileTimesheetsTableProps) => {
  const assignmentTitles = mappedTimesheetsData.map(
    (assignment: TimeTracking) => assignment.assignment
  );

  return (
    <MobileTimesheetsTablesWrapper>
      <MobileTitlesTable>
        <TableHeader>
          <MobileTimeSheetsHeaderRow headerTitle="ASSIGNMENT" />
        </TableHeader>
        {loadingTimesheets ? (
          <LoadingSpinner absolute />
        ) : (
          <>
            <TableBody>
              {assignmentTitles.map((assignment: TimeTrackingAssignment) => {
                return (
                  <MobileTimeSheetsBodyRow
                    assignmentInfo={assignment}
                    key={assignment.new_axsassignmentid}
                    anyPopupsOpen={anyPopupsOpen}
                    setAnyPopupsOpen={setAnyPopupsOpen}
                  />
                );
              })}
            </TableBody>
            <TableFooter>
              <MobileTimesheetsFooterRow footerTitle="DAILY TOTAL" />
            </TableFooter>
          </>
        )}
      </MobileTitlesTable>
      <MobileTimesheetsScroll>
        <MobileDataTable>
          <TableHeader>
            <MobileTimeSheetsHeaderRow headerData={headerData.slice(0)} />
          </TableHeader>
          {loadingTimesheets ? (
            <LoadingSpinner absolute />
          ) : (
            <>
              <TableBody>
                {mappedTimesheetsData.map((assignment: TimeTracking) => {
                  return (
                    <MobileTimeSheetsBodyRow
                      assignmentData={assignment}
                      key={assignment.assignment.new_axsassignmentid}
                      assignmentType={assignment.assignment.new_assignmenttype}
                      getAssignments={getAssignments}
                      anyPopupsOpen={anyPopupsOpen}
                      setAnyPopupsOpen={setAnyPopupsOpen}
                    />
                  );
                })}
              </TableBody>
              <TableFooter>
                <MobileTimesheetsFooterRow
                  data={footerData.slice(1)}
                  forecastedHours={forecastedHours}
                />
              </TableFooter>
            </>
          )}
        </MobileDataTable>
      </MobileTimesheetsScroll>
    </MobileTimesheetsTablesWrapper>
  );
};
